import {
  listExternalGMS as ListExternalGMSRequest,
  createExternalGMS as createExternalGMSRequest,
  deleteExternalGMS as deleteExternalGMSRequest,
  getExternalGMS as getExternalGMSRequest,
  updateExternalGMS as updateExternalGMSRequest
} from '@cbgms/api/modules/external-gms/requests'
import { ICreateExternalGMS, IExternalGMS, IExternalGMSResponse, IListExternalGMSResponse, IPaginatedRequest, IResponse } from '@cbgms/api'
import { createAsyncApiAction } from '@cbgms/base/redux/create-async-action'

export const listExternalGMS = (params: IPaginatedRequest) =>
  createAsyncApiAction<IListExternalGMSResponse>('support', ListExternalGMSRequest(params))

export const getExternalGMS = (externalGMSUUID: string) =>
  createAsyncApiAction<IExternalGMSResponse>('support', getExternalGMSRequest(externalGMSUUID))

export const updateExternalGMS = (externalGMSUUID: string, data: Partial<IExternalGMS>) =>
  createAsyncApiAction<IResponse<{ UUID: string }>>('support', updateExternalGMSRequest(externalGMSUUID, data))

export const deleteExternalGMS = (externalGMSUUID: string, dryRun: boolean) =>
  createAsyncApiAction<IResponse<{ UUID: string }>>('support', deleteExternalGMSRequest(externalGMSUUID, dryRun))

export const createExternalGMS = (data: ICreateExternalGMS) =>
  createAsyncApiAction<IResponse<{ UUID: string }>>('support', createExternalGMSRequest(data))
